/** Reference width of the primary right chat drawer column. */
export const RIGHT_DRAWER_REFERENCE_WIDTH_PX = 449;

/**
 * Width of overlay panels docked on the workline rail (Workline Settings,
 * conversation history, active tasks, etc.).
 */
export const RIGHT_SIDEBAR_OVERLAY_PANEL_WIDTH_PX = Math.round(
    RIGHT_DRAWER_REFERENCE_WIDTH_PX * 0.75,
);

/** Above `RightSidebarOverlayDrawerHost` panel (200001); matches k-tooltip overlay menus. */
export const RIGHT_SIDEBAR_OVERLAY_MENU_Z_INDEX = 200_002;
